import {NotificationTemplateRestDto} from "@/api/pharma-master-notification-template/models";
import {CommTypeEnum} from "@/api/enums/comm-type-enum";

export class NotificationTemplateRestDtoModel implements NotificationTemplateRestDto {

    comm_type_code: CommTypeEnum;
    language_code: string;
    content: string;
    subject: string;

    constructor(commTypeCode: CommTypeEnum, languageCode: string, content: string, subject: string) {
        this.comm_type_code = commTypeCode;
        this.language_code = languageCode;
        this.content = content;
        this.subject = subject;
    }

    public static createWithDefaults(): NotificationTemplateRestDtoModel {
        return new this(CommTypeEnum.EMAIL, 'nl', '', '');
    }
}
